import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../../i18n/I18nContext";

export default function PrivacyPolicy() {
  const { t } = useI18n();

  const sections = [
    {
      id: "contacto",
      title: "Contacto",
      content: (
        <>
          <p>
            {t(
              "Para qualquer informação adicional sobre algum texto, imagem ou funcionalidade do website, pedimos que nos envie um email para"
            )}{" "}
            <a
              href="mailto:geral@racksforall.eu"
              className="font-medium text-slate-900 underline decoration-slate-300 underline-offset-4 transition hover:decoration-slate-900"
            >
              geral@racksforall.eu
            </a>
            .
          </p>
        </>
      ),
    },
    {
      id: "protecao-dados",
      title: "Proteção de Dados",
      content: (
        <>
          <p>
            {t(
              "Todos os dados presentes nos diversos sistemas e bases de dados da Racksforall.eu foram recolhidos através de relações contratuais e intervenções profissionais com os clientes Racksforall.eu."
            )}
          </p>
          <p>
            {t(
              "A sua utilização é única e exclusivamente para fins referidos na presente política de privacidade, assim como para o envio de newsletters informativas e promocionais."
            )}
          </p>
          <p>
            {t(
              "Garantimos que os seus dados pessoais não serão transferidos para empresas terceiras nem comercializados."
            )}
          </p>
        </>
      ),
    },
    {
      id: "dados-utilizados",
      title: "Quais os dados utilizados?",
      content: (
        <>
          <p>
            {t(
              "Atualmente, a Racksforall.eu utiliza os dados pessoais essenciais para que o utilizador elabore um pedido de informação sobre os produtos."
            )}
          </p>

          <ul className="mt-4 space-y-3 text-slate-600">
            <li className="rounded-xl border border-slate-200 bg-white px-4 py-3">
              <strong className="text-slate-900">{t("Nome")}:</strong>{" "}
              {t("essencial para identificar o pedido e o cliente.")}
            </li>
            <li className="rounded-xl border border-slate-200 bg-white px-4 py-3">
              <strong className="text-slate-900">{t("Morada")}:</strong>{" "}
              {t("essencial para o envio da mercadoria.")}
            </li>
            <li className="rounded-xl border border-slate-200 bg-white px-4 py-3">
              <strong className="text-slate-900">{t("Email")}:</strong>{" "}
              {t("essencial para contactar o cliente e responder ao pedido realizado.")}
            </li>
            <li className="rounded-xl border border-slate-200 bg-white px-4 py-3">
              <strong className="text-slate-900">{t("Contacto telefónico")}:</strong>{" "}
              {t(
                "essencial para informar ou pedir informações específicas sobre o pedido."
              )}
            </li>
          </ul>
        </>
      ),
    },
    {
      id: "protecao",
      title: "Como protegemos os seus dados?",
      content: (
        <>
          <p>
            {t(
              "Os seus dados estão protegidos pela legislação aplicável e guardados num espaço onde apenas o responsável pela proteção de dados, ou pessoas autorizadas para o efeito, têm acesso."
            )}
          </p>
          <p>
            {t(
              "Pretendemos evitar a todo o custo a fuga total ou parcial dos dados pessoais dos nossos clientes."
            )}
          </p>
        </>
      ),
    },
    {
      id: "gestao",
      title: "Gestão dos dados pessoais",
      content: (
        <>
          <p>
            {t(
              "A recolha dos seus dados apenas será realizada com o seu consentimento."
            )}
          </p>
          <p>
            {t(
              "A utilização destes dados destina-se apenas à comunicação interempresarial e ao envio de newsletters informativas e promocionais."
            )}
          </p>
        </>
      ),
    },
    {
      id: "direitos-autor",
      title: "Direitos de autor",
      content: (
        <>
          <p>
            {t(
              "A Racksforall.eu está protegida pela lei portuguesa e internacional sobre a proteção de autor, proteção de dados e proteção da propriedade intelectual."
            )}
          </p>
          <p>
            {t(
              "Todos os conteúdos, imagens e vídeos foram concebidos internamente pela marca."
            )}
          </p>
        </>
      ),
    },
    {
      id: "email-marketing",
      title: "Email marketing",
      content: (
        <>
          <p>
            {t(
              "Ao realizar a inscrição na nossa newsletter, está a dar o seu consentimento voluntário para a utilização dos seus dados para envio de campanhas e ações de marketing realizadas pela Racksforall.eu."
            )}
          </p>
          <p>
            {t(
              "Para cancelar esse envio, basta clicar no final da newsletter ou enviar um email para"
            )}{" "}
            <a
              href="mailto:socialmedia@racksforal.eu"
              className="font-medium text-slate-900 underline decoration-slate-300 underline-offset-4 transition hover:decoration-slate-900"
            >
              socialmedia@racksforal.eu
            </a>
            .
          </p>
        </>
      ),
    },
    {
      id: "links",
      title: "Sistemas de links",
      content: (
        <>
          <p>
            {t(
              "Todo o sistema de links internos e externos utilizados no nosso website tem como finalidade melhorar a navegação e direcionar o utilizador para o que necessita."
            )}
          </p>
          <p>
            {t(
              "Não podemos assumir responsabilidade sobre problemas resultantes de links externos."
            )}
          </p>
        </>
      ),
    },
    {
      id: "cookies",
      title: "O que são cookies?",
      content: (
        <>
          <p>
            {t(
              "Os cookies são pequenos ficheiros de texto enviados para o seu computador ou dispositivo móvel quando visita websites."
            )}
          </p>
          <p>
            {t(
              "Os cookies ajudam os websites a armazenar e recuperar informação sobre os seus hábitos de navegação para personalizar a experiência."
            )}
          </p>
        </>
      ),
    },
    {
      id: "cookies-utilizados",
      title: "Cookies utilizados",
      content: (
        <>
          <p>
            {t(
              "No momento em que visita o nosso website podem ser alojados cookies no seu equipamento para melhorar a forma de navegar e o funcionamento do website."
            )}
          </p>

          <div className="mt-4 grid gap-4 md:grid-cols-2">
            <div className="rounded-2xl border border-slate-200 bg-white p-5">
              <h3 className="text-base font-semibold text-slate-900">
                {t("Cookies funcionais")}
              </h3>
              <ul className="mt-3 space-y-2 text-slate-600">
                <li>{t("Boa ligação ao website.")}</li>
                <li>{t("Supervisão dos dados resultantes da ligação.")}</li>
                <li>{t("Coerência gráfica do website.")}</li>
              </ul>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-5">
              <h3 className="text-base font-semibold text-slate-900">
                {t("Cookies publicitários")}
              </h3>
              <ul className="mt-3 space-y-2 text-slate-600">
                <li>{t("Apresentar e realçar anúncios promocionais.")}</li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>{t("Política de Privacidade | Racksforall")}</title>
        <meta
          name="description"
          content={t(
            "Consulta a nossa política de privacidade e proteção de dados pessoais, em conformidade com o RGPD."
          )}
        />
        <link rel="canonical" href="https://racksforall.pt/privacy-policy" />
        <meta
          property="og:title"
          content={t("Política de Privacidade | Racksforall")}
        />
        <meta property="og:url" content="https://racksforall.pt/privacy-policy" />
      </Helmet>
      <main className="min-h-screen bg-stone-50 pt-24 text-slate-900 md:pt-28">
        <section className="border-b border-slate-200">
          <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <p className="text-sm font-medium uppercase tracking-[0.22em] text-slate-500">
                Racksforall.eu
              </p>
              <h1 className="mt-4 text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
                {t("Política de Privacidade")}
              </h1>
              <p className="mt-6 text-lg leading-8 text-slate-600">
                {t(
                  "Levamos a proteção dos seus dados a sério. Nesta página pode consultar a forma como recolhemos, utilizamos e protegemos a sua informação pessoal ao navegar e interagir com a Racks For All."
                )}
              </p>
            </div>
          </div>
        </section>

        <section className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-12 sm:px-6 lg:grid-cols-[240px_minmax(0,1fr)] lg:px-8">
          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <p className="px-3 pb-3 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                {t("Índice")}
              </p>

              <nav className="space-y-1">
                {sections.map((section, index) => (
                  <a
                    key={section.id}
                    href={`#${section.id}`}
                    className="group flex items-center justify-between rounded-xl px-3 py-2 text-sm text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
                  >
                    <span>{t(section.title)}</span>
                    <span className="text-xs text-slate-400 transition group-hover:text-slate-700">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </a>
                ))}
              </nav>

              <div className="mt-6 rounded-xl bg-slate-900 p-4 text-sm text-white">
                <p className="font-medium">
                  {t("Precisas de mais informações?")}
                </p>

                <Link
                  to="/contact"
                  className="mt-3 inline-flex items-center rounded-full bg-white px-4 py-2 text-sm font-medium text-slate-900 transition hover:bg-slate-200"
                >
                  {t("Ir para Contactos")}
                </Link>
              </div>
            </div>
          </aside>

          <div className="space-y-6">
            {sections.map((section) => (
              <section
                key={section.id}
                id={section.id}
                className="scroll-mt-24 border-t border-slate-200 py-6 first:border-t-0 first:pt-0"
              >
                <div className="grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)] lg:gap-8">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
                      {t("Secção")}
                    </p>
                    <h2 className="mt-2 text-xl font-semibold text-slate-900">
                      {t(section.title)}
                    </h2>
                  </div>

                  <div className="max-w-3xl space-y-4 text-[15px] leading-7 text-slate-600">
                    {section.content}
                  </div>
                </div>
              </section>
            ))}

            <section className="border-t border-slate-200 py-6">
              <div className="grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)] lg:gap-8">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
                    {t("Apoio")}
                  </p>
                  <h2 className="mt-2 text-xl font-semibold text-slate-900">
                    {t("Contactar a equipa")}
                  </h2>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-6">
                  <p className="text-slate-600">
                    {t(
                      "Se precisares de esclarecimentos adicionais sobre proteção de dados, navegação ou utilização do website, entra em contacto connosco através da página de contactos."
                    )}
                  </p>

                  <Link
                    to="/contact"
                    className="mt-4 inline-flex items-center rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-slate-700"
                  >
                    {t("Ir para Contactos")}
                  </Link>
                </div>
              </div>
            </section>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
